import { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<boolean | undefined> = () => ({
  width: '100%',
  padding: (p) => p.spacing(1),
  background: (p) => p.palette.grey[200],
  borderRadius: (p) => p.spacing(0.5),
});

export const companyName: SxStyle = {
  display: 'block',
};
